module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens18-26d8c6d6f81cba0937af4d6c47e0f87f.jpg";